import { IItemParams } from './itemParams';
import { ItemSectionOption } from './itemSectionOption';

export interface IItemSection {
    type: SectionType;
    text: string;
    params: IItemParams[];
    options: ItemSectionOption[];
    visible: boolean;
}

export class ItemSection implements IItemSection {
    constructor(
        public type: SectionType,
        public text: string,
        public params: IItemParams[],
        public options: ItemSectionOption[] = [],
        public visible: boolean = true,
    ) { }
}

export enum SectionType {
    BODY_COLOR,
    FRONT_COLOR,
    SHELF_COLOR,
    WALL_COLOR,
    LEGS,
    HANDLES,
    FRAME,
    OTHER,
}
